import { useCallback } from 'react'
import { useLocalStorage } from 'react-use'
import { useImmerReducer } from "use-immer";

const usePersistReducer = (key, initialState, reducer) => {
  // grab saved value from `localStorage` and
  // a function to update it. if
  // no value is retrieved, use `INITIAL_STATE`
  const [savedState, saveState] = useLocalStorage(
    key,
    initialState,
  )

  // wrap `reducer` with a memoized function that
  // syncs the `newState` to `localStorage` before
  // returning `newState`. memoizing is important!
  const reducerLocalStorage = useCallback(
    (state, action) => {
      const newState = reducer(state, action)
      saveState(newState)

      return newState
    },
    [saveState],
  )

  // use wrapped reducer and the saved value from
  // `localStorage` as params to `useReducer`.
  // this will return `[state, dispatch]`
  return useImmerReducer(reducerLocalStorage, savedState)
}

export default usePersistReducer;